import React from 'react';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {GetABMViewDataResponse} from '../../../../../../../api/types/reportingApi.type';
import {BatchLevel} from '../../Helper';
import './DocCountSummaryView.scss';

interface Props {
  abmViewData: GetABMViewDataResponse;
  bathchLevel: BatchLevel;
}

const stringPath = 'reports.advanceBatchManagement.';
const DocCountSummaryView: React.FC<Props> = ({abmViewData, bathchLevel}) => {
  let totalSelectedDoc = 0;
  let inSelectedAssignments = 0;
  let completed = 0;
  let remaining = 0;

  if (abmViewData) {
    switch (bathchLevel) {
      case 'Document':
        totalSelectedDoc =
          abmViewData.documentReviewDetails?.netSelectedDocsFromSourceCount ??
          0;
        inSelectedAssignments =
          abmViewData?.documentReviewDetails?.netSelectedDocsFromFilterCount ??
          0;
        completed = abmViewData?.documentReviewDetails?.completedDocsCount ?? 0;
        remaining = abmViewData?.documentReviewDetails?.leftToDoDocsCount ?? 0;
        break;
      case 'Assignment':
        totalSelectedDoc =
          abmViewData?.assignmentreviewDetails?.netSelectedUniqueID ?? 0;
        inSelectedAssignments =
          abmViewData?.assignmentreviewDetails?.inSetLeftToDo ?? 0;
        completed = abmViewData?.assignmentreviewDetails?.inSetCompleted ?? 0;
        remaining = abmViewData?.assignmentreviewDetails?.inSetLeftToDo ?? 0;
        break;
      default:
        break;
    }
  }

  return (
    <Box className="document-count-summary">
      <Box className="left-side-container">
        <Box className="content-row content-row-border">
          <Typography
            className="typo-text label2_size title-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-typography`}
          >
            {t(stringPath + 'totalNetSelectedDocs')}
          </Typography>
          <Typography
            className="typo-text label2_size count-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-total-selected`}
          >
            {totalSelectedDoc.toLocaleString()}
          </Typography>
        </Box>
        <Box className="content-row">
          <Typography
            className="typo-text label2_size title-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-inselected-assignments-title`}
          >
            {t(stringPath + 'inSelectedAssignments')}
          </Typography>
          <Typography
            className="typo-text label2_size count-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-inselected-assignments`}
          >
            {inSelectedAssignments.toLocaleString()}
          </Typography>
        </Box>
      </Box>
      <Box className="right-side-container">
        <Box className="count-box">
          <Typography
            className="typo-text label2_size title-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-completed`}
          >
            {t(stringPath + 'completed')}
          </Typography>
          <Typography
            className="typo-text display3_size count-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-completed-value`}
          >
            {completed.toLocaleString()}
          </Typography>
        </Box>
        <Box className="count-box">
          <Typography
            className="typo-text label2_size title-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-remaining`}
          >
            {t(stringPath + 'remaining')}
          </Typography>
          <Typography
            className="typo-text display3_size count-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-remaining-value`}
          >
            {remaining.toLocaleString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DocCountSummaryView;
